import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useState, type ReactNode } from 'react';
import { AuthProvider } from '../features/auth/AuthContext';
import { ThemeProvider } from '../theme/ThemeContext';

/**
 * Bündelt die globalen Anbieter der Anwendung (Serverzustand, Anmeldestatus, Theme).
 * Der QueryClient wird je Komponenteninstanz einmal angelegt.
 * @param props.children Die umschlossene Anwendung.
 */
export function Providers({ children }: { children: ReactNode }) {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: { queries: { staleTime: 30_000, refetchOnWindowFocus: false } },
      }),
  );
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <AuthProvider>{children}</AuthProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}
